import { PhoneInput } from '@/components/phone-input';
import { CustomerInfo } from '@/lib/api/types';
import { Button } from '@/ui/button';
import { Input } from '@/ui/input';
import { Label } from '@/ui/label';
import { Formik } from 'formik';
import { CalendarCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface CustomerFormProps {
  onSubmit: (values: CustomerInfo) => void;
}

export function CustomerForm({ onSubmit }: CustomerFormProps) {
  const { t } = useTranslation();

  return (
    <Formik<CustomerInfo>
      initialValues={{
        name: '',
        email: '',
        phone: '',
      }}
      onSubmit={(values) => {
        onSubmit(values as CustomerInfo);
      }}
    >
      {({
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => (
        <form onSubmit={handleSubmit} className="space-y-2">
          <FormField
            id="name"
            label={t('components.booking-form.customer.name')}
            type="text"
            name="name"
            placeholder="Paolo Rossi"
            value={values.name}
            handleChange={handleChange}
            handleBlur={handleBlur}
          />
          <FormField
            id="email"
            label={t('components.booking-form.customer.email')}
            type="email"
            name="email"
            placeholder="me@example.com"
            value={values.email}
            handleChange={handleChange}
            handleBlur={handleBlur}
          />
          <div>
            <Label htmlFor="phone">
              {t('components.booking-form.customer.phone')}
            </Label>
            <PhoneInput
              defaultCountry="IT"
              name="phone"
              value={values.phone}
              onChange={(value) => handleChange('phone')(value)}
              onBlur={handleBlur}
              required
            />
          </div>
          <div className="pt-6">
            <Button type="submit" disabled={isSubmitting} size="lg">
              <CalendarCheck className="mr-2 size-4" />
              {t('components.booking-form.book-now')}
            </Button>
          </div>
        </form>
      )}
    </Formik>
  );
}

interface FormFieldProps {
  id: string;
  label: string;
  type: string;
  name: string;
  placeholder: string;
  value: string;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
}

function FormField({
  id,
  label,
  type,
  name,
  placeholder,
  value,
  handleChange,
  handleBlur,
}: FormFieldProps) {
  return (
    <div>
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        type={type}
        name={name}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        required
      />
    </div>
  );
}

export default CustomerForm;